import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";

import Spinner from "@atlaskit/spinner";

import { iconsService } from "./iconsService";

const MacroIconView = ({ icon, style }) => {
  const [svg, setSvg] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const mountedRef = useRef(null);

  const fetchIcons = useCallback(
    async (iconToFetch) => {
      try {
        const iconSVG = await iconsService.fetchIcons(iconToFetch);

        if (!mountedRef.current) return null;

        setSvg(iconSVG?.data?.svg);
        setLoading(false);
        return iconSVG?.data?.svg;
      } catch (error) {
        return null;
      }
    },
    [mountedRef]
  );

  useEffect(() => {
    mountedRef.current = true;
    setLoading(true);
    (async () => {
      await fetchIcons(icon);
    })();
    return () => {
      mountedRef.current = false;
      setLoading(false);
    };
  }, [icon, fetchIcons]);

  if (loading) return <Spinner />;

  return <div style={style} dangerouslySetInnerHTML={{ __html: svg }} />;
};

MacroIconView.defaultProps = {
  style: {},
};

MacroIconView.propTypes = {
  icon: PropTypes.string.isRequired,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
};

export default MacroIconView;
